const { omitBy, isNil } = require('lodash');

// This function removes null and undefined properties from an object, which is
// especially useful when specifying variables for an Apollo Client request.
const omitNil = obj => omitBy(obj, isNil);

export default omitNil;
